<template>
  <div class="author-regist-bg">
    <div class="author-regist">
      <div class="container">
        <div class="c-content-header">
          <ContentHeader title="欢迎注册有看投大咖"></ContentHeader>
        </div>
        <div class="content">
          <div class="left">
            <div class="c-steep">
              <Step v-bind:stepContent="stepContent"></Step>
            </div>
            <!-- 注册账号 -->
            <div v-if="!stepComleted.regist" class="c-author-regist-comp">
              <SmsSend
                @SendSmsCode="SendSmsCode"
                @SendSmsSubmit="SendSmsSubmit"
              ></SmsSend>
            </div>
            <!-- 身份认证 -->
            <div
              v-else-if="!stepComleted.authorInfo"
              class="c-author-regist-comp"
            >
              <div class="c-author-content">
                <AuthorInfoContent
                  v-on:submit="contentSubmit"
                ></AuthorInfoContent>
              </div>
            </div>
            <!-- 填写资料 -->
            <div
              v-else-if="!stepComleted.perfectInfo"
              class="c-author-regist-comp"
            >
              <div class="author-regist-perfect">
                <div class="form-item">
                  <div>
                    <div class="form-item-sp">
                      <span class="form-item-sp-must">*</span>
                      <span>擅长投资品种（请选择1-3项）</span>
                    </div>
                    <div
                      class="form-item-inp"
                      :class="{
                        'is-error':
                          preSubmit && inputPerfectInfo.tagexpert.length === 0
                      }"
                    >
                      <div class="form-item-ck-bg form-item-ck-3">
                        <el-checkbox-group v-model="inputPerfectInfo.tagexpert">
                          <el-checkbox label="A股"></el-checkbox>
                          <el-checkbox label="港股"></el-checkbox>
                          <el-checkbox label="美股"></el-checkbox>
                          <el-checkbox label="基金"></el-checkbox>
                          <el-checkbox label="期货"></el-checkbox>
                          <el-checkbox label="其他"></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-item">
                  <div>
                    <div class="form-item-sp">
                      <span class="form-item-sp-must">*</span>
                      <span>能力标签（请选择1-5项）</span>
                    </div>
                    <div
                      class="form-item-inp"
                      :class="{
                        'is-error':
                          preSubmit && inputPerfectInfo.tagskill.length === 0
                      }"
                    >
                      <div class="form-item-ck-bg">
                        <el-checkbox-group v-model="inputPerfectInfo.tagskill">
                          <el-checkbox label="波段操作"></el-checkbox>
                          <el-checkbox label="中短线"></el-checkbox>
                          <el-checkbox label="中长线"></el-checkbox>
                          <el-checkbox label="基金理财"></el-checkbox>
                          <el-checkbox label="基本面"></el-checkbox>
                          <el-checkbox label="趋势交易"></el-checkbox>
                          <el-checkbox label="量化投资"></el-checkbox>
                          <el-checkbox label="行业分析"></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-item">
                  <div>
                    <div class="form-item-sp">
                      <span class="form-item-sp-must">*</span>
                      <span>简介:</span>
                    </div>
                    <div class="form-item-inp">
                      <div
                        class="form-item-inp-area"
                        :class="{
                          'is-error': preSubmit && !inputPerfectInfo.remark
                        }"
                      >
                        <el-input
                          type="textarea"
                          :rows="10"
                          placeholder="请输入个人简介"
                          v-model="inputPerfectInfo.remark"
                          maxlength="300"
                          show-word-limit
                        >
                        </el-input>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-item">
                  <div>
                    <div class="form-item-sp"></div>
                    <div>
                      <div class="form-item-btn">
                        <el-button
                          :loading="loading"
                          @click.native="perfectSubmit"
                          type="primary"
                          >提交</el-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 提交申请 -->
            <div v-else-if="stepComleted.submit" class="c-author-regist-comp">
              <Successed
                @SuccSubmit="SuccSubmit"
                v-bind:post="{
                  text: isAuditing ? '提交申请成功' : '申请失败',
                  btnText: '重新提交',
                  notify: isAuditing
                    ? [
                        '工作人员将在3个工作日内通知您﹐请耐心等待',
                        '客服电话:400-602-1010'
                      ]
                    : [
                        '认证资料不足，请重新填写资料后提交，有问题请拨打',
                        '客服电话:400-602-1010'
                      ],
                  btnShow: !isAuditing,
                  success: isAuditing
                }"
              ></Successed>
            </div>
          </div>
          <div class="line"></div>
          <div class="right">
            <div>
              <span class="e-sp">已有账号，请</span>
              <a class="e-a" v-on:click="goLogin()">直接登录</a>
            </div>
          </div>
          <div class="blank"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import store from '@/store'
import ContentHeader from '@/components/ContentHeader'
import Step from '@/components/Step'
import Successed from '@/components/Successed'
import AuthorInfoContent from '@/components/AuthorInfoContent'
import router from '@/router'
import SmsSend from '@/components/PassWord/SmsSend'
import { login, sendSmsCode } from '@/api/account'
import { upsertAuthor } from '@/api/author'

export default {
  name: 'AuthorRegist',
  components: {
    ContentHeader,
    Step,
    Successed,
    AuthorInfoContent,
    SmsSend
  },
  data() {
    return {
      textarea: '',
      isPassWordLogin: true,
      compPassWord: 'PassWord',
      stepComleted: {
        regist: false,
        authorInfo: false,
        perfectInfo: false,
        submit: false
      },
      inputAuthorInfo: {},
      inputPerfectInfo: {
        tagexpert: [],
        tagskill: [],
        remark: ''
      },
      preSubmit: false,
      loading: false,
      auditStatus: -1,
      submitedIndex: false
    }
  },
  computed: {
    stepContent() {
      return [
        {
          step: 1,
          name: '注册账号',
          isCompleted: this.stepComleted.regist
        },
        {
          step: 2,
          name: '身份认证',
          isCompleted: this.stepComleted.authorInfo
        },
        {
          step: 3,
          name: '填写资料',
          isCompleted: this.stepComleted.perfectInfo
        },
        {
          step: 4,
          name: '提交申请',
          isCompleted: this.stepComleted.submit
        }
      ]
    },
    pwContent() {
      return {
        step: 1,
        succText: '重置密码完成'
      }
    },
    isLogin() {
      // return true
      return this.$store.getters['auth/isLogin']
    },
    contentComp() {
      return 'PassWord'
    },
    // 对于审核结果，资料是否在审核中
    isAuditing() {
      // return false
      return this.auditStatus !== 2 || this.submitedIndex
    }
  },
  methods: {
    changeTab(index) {
      this.isPassWordLogin = index
    },
    goLogin() {
      this.$store.dispatch('auth/clearAuthInfo')
      router.push('/excl-author')
    },
    handlerChange: function (val) {
      console.log(val)
      this.address = val
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    showError(msg) {
      if (!msg) {
        msg = '数据请求发生异常，请稍后再试。'
      }

      this.$notify.error({
        position: 'bottom-right',
        title: '错误',
        message: msg
      })
    },
    // 发送注册短信验证码
    async SendSmsCode(info) {
      const { result } = await sendSmsCode(
        info.phone,
        this.imageKey,
        this.imageCode
      ).catch(data => {
        console.log('error:', data)
        this.showError()
      })
      if (result.code === 0) {
        this.$notify({
          position: 'bottom-right',
          title: '成功',
          message: '短信验证码发送成功',
          type: 'success'
        })
      } else if (result.code === 100 || result.code === 22203) {
        this.showError(result.msg)
      } else {
        console.log('error', result)
        this.showError()
      }
    },
    // 手机号注册，下一步
    async SendSmsSubmit(info) {
      const { result, detail } = await login(
        info.phone,
        info.smsCode,
        dayjs(+process.env.VUE_APP_VERSION).format('YYYY.M.D')
      ).catch(data => {
        console.log('error:', data)
        this.showError()
      })
      if (result.code === 0) {
        // 注册成功
        delete detail.accId
        store.commit('auth/setLoginInfo', detail)
        // 获取用户基础信息
        await store.dispatch('user/getUserInfo')
        // 获取权限
        store.dispatch('right/getAllRightList')

        // 若当前用户在申请中，也有大咖信息 // 获取大咖基础信息
        await store.dispatch('user/getAuthorInfo')

        // 如果用户已经是大咖
        if (store.getters['user/isAuthor']) {
          // 提示跳转个人首页
          this.$alert('您已经是大咖身份，请跳转个人中心。', '提示', {
            confirmButtonText: '确定',
            showClose: false,
            type: 'info',
            callback: () => {
              router.push('/excl-author/mine')
            }
          })
        } else {
          // 判读是否申请过
          this.setAudited()
          this.stepComleted.regist = true
        }
      } else if (result.code === 22206) {
        this.showError(result.msg)
      } else {
        console.log('error', result)
        this.showError()
      }
    },
    setAudited() {
      // 如果是编辑中
      if (store.state.user.authorInfo) {
        if (
          store.state.user.authorInfo.checkstatus === 0 ||
          store.state.user.authorInfo.checkstatus === 2
        ) {
          this.stepComleted.authorInfo = true
          this.stepComleted.perfectInfo = true
          this.stepComleted.submit = true

          // isAuditing
          this.auditStatus = store.state.user.authorInfo.checkstatus
        }

        // 填写资料信息赋值
        this.inputPerfectInfo.tagexpert = store.state.user.authorInfo.tagexpert
          ? JSON.parse(store.state.user.authorInfo.tagexpert)
          : []
        this.inputPerfectInfo.tagskill = store.state.user.authorInfo.tagskill
          ? JSON.parse(store.state.user.authorInfo.tagskill)
          : []
        this.inputPerfectInfo.remark = store.state.user.authorInfo.remark
      }
    },
    // 身份认证-下一步
    contentSubmit(info) {
      this.inputAuthorInfo = info
      console.log('contentSubmit info:', info)
      this.stepComleted.authorInfo = true
      this.inputAuthorInfo = info
    },
    // 填写资料-提交
    async perfectSubmit() {
      console.log('perfectSubmit info:', this.inputPerfectInfo)
      this.preSubmit = true
      this.loading = true
      // 校验填写资料完善性
      if (!this.validatePerfectInfo()) {
        return false
      }
      var data = {}
      Object.assign(data, this.inputAuthorInfo, this.inputPerfectInfo)
      data.mobilephone = this.$store.state.auth.loginInfo.mobile
      const { result } = await upsertAuthor(data).catch(data => {
        console.log('upsertAuthor error:', data)
        this.showError()
      })
      if (result.code === 0) {
        this.submitedIndex = true
        await store.dispatch('user/getAuthorInfo')
        // 提交成功
        this.stepComleted.perfectInfo = true
        this.stepComleted.submit = true
      } else if (result.code === 22206) {
        this.showError(result.msg)
      } else {
        console.log('error', result)
        this.showError()
      }
      this.loading = false
    },
    validatePerfectInfo() {
      return (
        this.inputPerfectInfo.tagexpert.length > 0 &&
        this.inputPerfectInfo.tagskill.length > 0 &&
        this.inputPerfectInfo.remark
      )
    },
    // 重新提交
    SuccSubmit() {
      this.stepComleted.authorInfo = false
      this.stepComleted.perfectInfo = false
      this.stepComleted.submit = false
      console.log('SuccSubmit')
    }
  },
  async mounted() {},
  async created() {
    // 初始化进度条
    this.stepComleted.regist = this.isLogin
    // 初始化页面时，若已登录但未有大咖信息，主动获取
    if (this.isLogin) {
      await store.dispatch('user/getAuthorInfo')
    }
    this.setAudited()
  },
  beforeCreate() {
    // 已经是大咖，直接跳转至个人首页
    if (store.getters['auth/isLogin'] && store.getters['user/isAuthor']) {
      router.push('/excl-author/mine')
    }
  }
}
</script>

<style>
.author-regist-perfect .form-item-inp .form-item-ck-bg .el-checkbox__label {
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 40px;
  letter-spacing: 0px;
  color: #262626;
}
.author-regist-perfect .form-item-inp .form-item-ck-bg .el-checkbox-group {
  padding: 0 30px;
}
.author-regist-perfect .form-item-inp .form-item-ck-3 .el-checkbox-group {
  width: 80%;
}
.author-regist-perfect .form-item-inp .form-item-ck-bg .el-checkbox {
  width: 90px;
}
.author-regist-perfect .form-item-inp .form-item-inp-area .el-textarea__inner {
  background-color: #fff;
}
.author-regist-perfect .form-item-inp .is-error .el-textarea__inner {
  border-color: #e64c2e;
}
.author-regist-perfect .form-item .form-item-btn .el-button {
  width: 180px;
  font-size: 16px;
  line-height: 14px;
}
.is-disabled {
  background-color: #fafafa;
}
.author-regist-perfect
  .form-item
  .form-item-ck-bg
  .is-checked
  .el-checkbox__inner {
  background-color: #046bcc;
  border-color: #046bcc;
}
.author-regist-perfect
  .form-item
  .form-item-ck-bg
  .is-checked
  .el-checkbox__label {
  color: #046bcc;
}
/* 提醒框 */
.el-message-box__btns .el-button {
  width: 100px;
}
.el-message-box__content .el-message-box__message {
  /* padding: 15px 0px 15px 30px; */
  color: #606266;
}
.el-message-box .el-message-box__btns {
  padding-bottom: 3px;
}
</style>

<style lang="scss" scoped>
.author-regist-bg {
  background-color: #f0f0f0;
}
.author-regist {
  width: 1200px;
  background-color: #f0f0f0;
  margin: 0 auto;
  .container {
    background-color: #ffffff;
    width: 100%;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    .c-content-header {
      margin: 0 100px;
    }
    .content {
      display: flex;
      margin-bottom: 80px;
      .left {
        width: 860px;
        height: 100%;
        // border: solid 1px red;
        display: flex;
        flex-direction: column;
        align-items: center;
        .c-steep {
          margin: 40px 0 30px;
        }
        .c-author-regist-comp {
          margin: 20px 0 16px;
          .c-author-content {
            margin-left: 80px;
          }
          .author-regist-perfect {
            display: flex;
            flex-direction: column;
            // padding-left: 115px;
            .form-item {
              display: flex;
              margin-top: 30px;
              .form-item-btn {
                width: 180px;
                height: 44px;
              }
              .form-item-sp {
                font-family: MicrosoftYaHei;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 40px;
                letter-spacing: 0px;
                // color: #858585;
                color: #606266;
                .form-item-sp-must {
                  color: #e64c2e;
                }
              }
              .form-item-inp {
                .form-item-ck-bg {
                  width: 570px;
                  height: 110px;
                  background-color: #fafafa;
                  border-radius: 5px;
                  display: flex;
                  align-items: center;
                  border: 1px solid #fafafa;
                }
                .form-item-inp-area {
                  width: 570px;
                }
              }
              .is-error .form-item-ck-bg {
                border-color: #e64c2e;
              }
            }
          }
        }
      }
      .line {
        margin: 60px 0;
        width: 1px;
        background-color: #ebebeb;
      }
      .right {
        width: 239px;
        display: inline-flex;
        justify-content: flex-end;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
        margin-top: 250px;
        .e-sp {
          width: 140px;
          height: 14px;
          color: #858585;
        }
        .e-a {
          width: 140px;
          height: 14px;
          color: #046bcc;
          text-decoration: none;
          cursor: pointer;
        }
      }
      .blank {
        width: 100px;
      }
    }
  }
}
</style>
